import {displayChartUpCircleDollarIcon, fileChartPieIcon, filterCircleXmarkIcon, textSizeIcon} from './Icons';

export const ExtendedIconMap = Object.freeze({
    FILTER_CLEAR: filterCircleXmarkIcon(),
    PORTFOLIO: displayChartUpCircleDollarIcon(),
    TEXT_SIZE_INCREASE: textSizeIcon({flip: 'horizontal'}),
    TEXT_SIZE_DECREASE: textSizeIcon(),
    FILE_CHART_PIE: fileChartPieIcon()
});
